module.exports = __webpack_public_path__ + "static/media/2.f291d885.svg";